import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DynamicPageMutationKeys } from '../../../keys'
import {
	UpdateDynamicPageRequest,
	UpdateDynamicPageResponse,
} from '../../../type'
import { updateDynamicPage } from '../../services'

interface UseMutationUpdateDynamicPageProps {
	id: string
	payload: UpdateDynamicPageRequest
}

export default function useMutationUpdateDynamicPage(
	props?: UseBaseMutationOptions<
		UpdateDynamicPageResponse,
		UseMutationUpdateDynamicPageProps
	>,
) {
	return useMutation({
		mutationKey: [DynamicPageMutationKeys.UpdateDynamicPage],
		mutationFn: (params) => updateDynamicPage(params.id, params.payload),
		...props,
	})
}
